module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "正在进行",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "计划开始",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已结束",
      "name": "3"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.list), function(month) {
    return (month.list.length > 0) ? _c('div', [_c('div', {
      staticClass: "data-times"
    }, [_vm._v(_vm._s(month.title))]), _vm._v(" "), (month.list.length > 0) ? _c('div', {
      staticClass: "sai-items-wrap"
    }, _vm._l((month.list), function(item) {
      return _c('div', {
        staticClass: "sai-itmes-li"
      }, [_c('div', {
        staticClass: "train-items-top show-two-row items-top1",
        style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
      }, [(item.is_online == 1) ? _c('div', {
        staticClass: "sai-type-tip"
      }, [_vm._v("线上")]) : _c('div', {
        staticClass: "sai-type-tip offline"
      }, [_vm._v("线下")]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
        staticClass: "sai-info-box",
        staticStyle: {
          "flex": "1"
        }
      }, [_c('p', {
        staticClass: "sai-title show-two-row"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      }, [(item.status == 1) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v("未开始")]) : (item.status == 2) ? _c('el-tag', {
        attrs: {
          "type": "success"
        }
      }, [_vm._v("正在报名")]) : (item.status == 3) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v("报名结束")]) : (item.status == 4) ? _c('el-tag', {
        attrs: {
          "type": "success"
        }
      }, [_vm._v("正在比赛")]) : (item.status == 5) ? _c('el-tag', {
        attrs: {
          "type": "warning"
        }
      }, [_vm._v("已结束")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      })]), _vm._v(" "), _c('el-row', [(item.status < 3) ? _c('el-button', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'ISaiApplyFormStep1',
            query: {
              saiqu_id: item.id
            }
          }),
          expression: "{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
        }],
        attrs: {
          "type": "primary"
        }
      }, [_vm._v("报名\n            ")]) : _vm._e(), _vm._v(" "), (item.status != 1) ? _c('el-button', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'ActivityActivity',
            query: {
              id: item.activity_id
            }
          }),
          expression: "{name:'ActivityActivity',query:{id:item.activity_id}}"
        }],
        attrs: {
          "type": "primary",
          "plain": ""
        }
      }, [_vm._v("进入\n            ")]) : _vm._e()], 1)], 1)
    }), 0) : _vm._e()]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559c2e29","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiDateList.vue
// module id = 1490
// module chunks = 0